import * as React from "react"
import { useTranslation } from "react-i18next"

import Tabs from "shared/components/Tabs"
import useEditor from "shared/hooks/useEditor"
import { DealLineId } from "shared/hubrise/ids"
import { IDeal, IDealLine } from "shared/hubrise/models"
import * as Sku from "shared/hubrise/utils/Sku"
import { findById } from "shared/utils/javascript"

import DealLineSkus from "./DealLineSkus"
import { StyledLinesSkus, Title } from "./Styles"
import { SkuMap } from "./types"

interface LinesSkusProps {
  deal: IDeal
}

const LinesSkus = ({ deal }: LinesSkusProps): JSX.Element => {
  const { t } = useTranslation()
  const { catalog } = useEditor()

  const [activeDealLineId, setActiveDealLineId] = React.useState<DealLineId>(deal.lines[0].id)
  const dealLine: IDealLine = findById(deal.lines, activeDealLineId)!

  const skuMap = React.useMemo<SkuMap>(() => {
    const map: SkuMap = new Map() as SkuMap
    deal.lines.forEach((dealLine) =>
      dealLine.skus.forEach(({ skuId }) => {
        if (!map.get(skuId)) map.set(skuId, Sku.findWithProductById(catalog, skuId))
      }),
    )
    return map
  }, [catalog, deal.lines])

  return (
    <StyledLinesSkus>
      <Title>{t("deal.lines.title")}</Title>

      <Tabs
        items={deal.lines}
        selectedItem={dealLine}
        onSelect={({ id }) => setActiveDealLineId(id)}
        label={(dealLine) => {
          return dealLine.label === "" ? String(deal.lines.indexOf(dealLine) + 1) : dealLine.label
        }}
      />

      <DealLineSkus deal={deal} dealLine={dealLine} skuMap={skuMap} />
    </StyledLinesSkus>
  )
}

export default LinesSkus
